import React, { useEffect } from 'react'
import styles from './styles.module.css'
import Button from '../../components/Button'
import { IoIosAdd } from 'react-icons/io'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { useState } from 'react'
import Modal from './Modal'
import Confirmation from '../../components/Confirmation/Confirmation'
import { Checkbox, Input, } from '../../components/ModalInputs'
import moment from 'moment'
import CustomSelect from '../../components/CustomSelect'
import { getSchoolYears, getTermTypes, } from '../../actions/common'
import { getTermsList } from '../../actions/terms'
import { arrayForSelect } from '../../utils/arrayForSelect'
import { createInitialImport, setInitialImportFile } from '../../actions/InitialImport'
import Table from '../../components/Table'


const dateFormat = 'YYYY-MM-DD'; // Тип даты
const defaultDate = { begin_date: moment(new Date()).format(dateFormat), end_date: moment(new Date()).format(dateFormat) }; // Дата по умолчанию
const whosAsking = [
  { title: 'Классы', name: 'page_class', ind: 1 },
  { title: 'Предметы', name: 'page_course', ind: 2 },
  { title: 'Кабинеты', name: 'page_room', ind: 3 },
  { title: 'Учащиеся', name: 'page_student', ind: 4 },
  { title: 'Преподаватели', name: 'page_teacher', ind: 5 },
  { title: 'Учебные периоды', name: 'page_term', ind: 6 },
  { title: 'Распорядок дня', name: 'page_period', ind: 7 },
  { title: 'Преподаватели-кабинеты', name: 'page_teacher_room', ind: 8 },
  { title: 'Преподаватели-предметы', name: 'page_teacher_course', ind: 9 },
  { title: 'Классные руководители', name: 'page_teacher_class', ind: 10 },
  { title: 'Нагрузка преподавателей', name: 'page_teacher_load', ind: 11 },

]


export default function InitialImport() {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  /// ПОДТВЕРДИТЬ ДАННЫЕ
  const { schoolYears, termTypes } = useSelector(state => state.common)
  const { list: termsList } = useSelector(state => state.terms)

  const { initial_import_table } = useSelector(state => state.initial_import)

  const [selectedItem, setSelectedItem] = useState(null)
  const [confirmation, setConfirmation] = useState(false);
  const [tableArr, setTableArr] = useState(defaultDate);

  const [who, setWho] = useState([])
  const [values, setValues] = useState([]) // залипуха - не ясно как д.б.

  const arrHeaders = initial_import_table && Object.values(initial_import_table?.dict)
  const arrValuesName = initial_import_table && Object.entries(initial_import_table?.dict)

  useEffect(() => {
    dispatch(getSchoolYears())
    dispatch(getTermTypes())
    setValues({
      "year": 19,
      "term_type": 1,
      "term": 82,
      "date": "2025-06-09"
    })
  }, [])

  useEffect(() => {
    initial_import_table && setTableArr(initial_import_table)
  }, [initial_import_table])

  useEffect(() => {
    values.year && dispatch(getTermsList(values.year))
  }, [values.year])

  useEffect(() => {
    const request = { data: tableArr, ...values }
    tableArr && dispatch(createInitialImport(request))
  }, [tableArr])

  const openModal = (data) => () => {
    setSelectedItem(data || {})
  }

  const closeModal = () => setSelectedItem(null)

  const acceptConfirmation = () => {
    closeModal();
    setConfirmation(false);
  };
  const rejectConfirmation = () => {
    setConfirmation(false);
  };

  const handleChangeCheck = (e) => {
    const item = e.target.value
    setWho(item)
  }

  const handleChange = (name, item) => {
    setValues({ ...values, [name]: item })
  }

  const handlePick = () => {
    document.getElementById('filePicker').click()
  }

  const handleChangeFile = (e) => {
    dispatch(setInitialImportFile(Object.values(e.target.files)[0], who))
  }

  const renderLi = (data) => {
    const { result } = data
    return (
      result && result?.map(renderLiLI)
    )
  }

  const renderLiLI = (data) => {
    const row = Object.values(data)
    return (
      <tr onClick={openModal(data)}>
        {row.map(cell => <td>{cell}</td>)}
      </tr >
    )
  }

  const handleChangeRow = (data) => {
    setTableArr(prev => ({ ...prev, result: [...prev.result, data] }))
    closeModal()
  }

  return (
    <div className={styles.wrapper} style={{ width: '1200px', margin: '0 auto' }}>
      {confirmation && (
        <Confirmation
          top="30px"
          left="40px"
          title={`Вы уверены, что хотите удалить ${confirmation.name}?`}
          acceptConfirmation={() => acceptConfirmation(confirmation?.name)}
          rejectConfirmation={rejectConfirmation}
        />
      )}
      {selectedItem &&
        <Modal
          closeModal={closeModal}
          data={selectedItem}
          headers={arrHeaders}
          arrValuesName={arrValuesName}
          addMode={selectedItem === 'add'}
          handleChangeRow={handleChangeRow}
        // intName={intName}
        // setIntName={setIntName}
        />
      }
      <h1>Импорт данных</h1>
      <div style={{ display: 'flex' }}>
        <div>
          <div className={styles.inputsColumn}>
            <p>Состав данных для экспорта</p>
            <div className={styles.checkboxArea}>
              {whosAsking?.map(par => {
                const che = who === par.name
                return (
                  <Checkbox
                    label={par.title}
                    checked={!!che}
                    value={par.name}
                    onChange={(e) => handleChangeCheck(e)}
                    name='who'
                  // disabled={disabledList2?.find(el => el == par)}
                  />
                )
              }
              )}
            </div>
          </div>
          <div style={{ display: 'flex', flexDirection: "row" }}>
            <Button
              style={{ padding: '.5rem 1.5rem', margin: '12px' }}
              onClick={handlePick}
            >
              <IoIosAdd size={30} />
              Файл
            </Button>
            <input
              className={styles.hidden}
              type='file'
              onChange={handleChangeFile}
              // accept="file/*"
              id='filePicker'
            />
          </div>
          <div className={styles.inputsColumn}>
            <CustomSelect
              title="Учебный год"
              valuesName="year"
              options={schoolYears && arrayForSelect(schoolYears, 'name', 'xp_key')}
              width='120px'
              value={values.year}
              setFieldValue={handleChange}
            />
            <CustomSelect
              title='Тип уч/п'
              valuesName="term_type"
              options={termTypes && arrayForSelect(termTypes, 'term_type_name', 'term_type_id')}
              width='120px'
              value={values.term_type}
              setFieldValue={handleChange}
            />
            <CustomSelect
              title="Учебный период"
              valuesName="term"
              value={values.term}
              width='120px'
              options={termsList && arrayForSelect(termsList, 'title', 'trmid')}
              setFieldValue={handleChange}
            />
            <Input
              type='date'
              label='Дата'
              value={values.date}
              onChange={(e) => handleChange('date', e.target.value)}
            />
          </div>
        </div>
        <div>
          <div>

            <Table style={{ marginTop: '2rem', backgroundColor: 'white' }}>
              <thead>
                <tr style={{ cursor: 'pointer', background: 'white' }}>
                  {arrHeaders?.map(el =>
                    <td>{el}</td>
                  )}
                </tr >

              </thead>
              <tbody>
                {tableArr && [tableArr]?.map(renderLi)}
              </tbody>

            </Table>
          </div>

          <Button
            style={{ padding: '.5rem 1.5rem' }}
            onClick={openModal('add')}
          >
            <IoIosAdd size={30} />
            Добавить
          </Button>
        </div>

      </div>
    </div>

  )
}
